import React, { useState, useEffect } from 'react'
import { Header } from '@cwp/amp-microsites/build/components.es.js'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../shared/utils/common-utils'
import { useFetch } from '../../shared/utils/hooks'
import { reactToCwp } from '../../../common/react-utils'
import './header.css'

const HeaderMicrosite = props => {
  const { menuName, layout, header } = props.content
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleWindowSizeChange)
    setWindowWidth(window.innerWidth)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const [headerDocument, setHeaderDocument] = useState(null)
  const env = getCWPEnvironmentForURL(window.location.href)

  useEffect(() => {
    if (header) {
      setHeaderDocument(header)
    }
  }, [header])

  const micrositeMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
  const micrositeMainMenu = useFetch(windowWidth < 1025 ? micrositeMenuUrl : '')

  return (
    <Header
      headerDocument={headerDocument}
      mainMenu={micrositeMainMenu}
      backgroundColor={'u-bgColorWhite'}
      textColor={'u-textColorActionBlue'}
      menuIconColor={'u-bgColorActionBlue'}
      layoutClass={layout}
    />
  )
}

export default reactToCwp(HeaderMicrosite)
